const LABELS: Record<string, string> = {
  RECEIVED: 'Received',
  IDENTIFICATION_PENDING: 'Awaiting identification',
  IDENTIFIED: 'Identified',
  STORAGE_ASSIGNED: 'In storage',
  IN_MORTUARY: 'In mortuary',
  POST_MORTEM_PENDING: 'Autopsy pending',
  POST_MORTEM_COMPLETED: 'Autopsy done',
  AUTOPSY_PENDING: 'Autopsy pending',
  AUTOPSY_IN_PROGRESS: 'Autopsy in progress',
  AUTOPSY_COMPLETED: 'Autopsy done',
  RELEASE_PENDING: 'Awaiting release',
  RELEASED: 'Released',
  TRANSFERRED: 'Transferred',
  UNCLAIMED: 'Unclaimed',
  DISPOSED: 'Closed',
  FINAL_DISPOSITION_COMPLETED: 'Closed',
  CEMETERY: 'Burial',
  CREMATORIUM: 'Cremation',
  UNIDENTIFIED: 'Unidentified',
  PARTIALLY_IDENTIFIED: 'Partially identified',
  UNKNOWN: 'Unknown',
  AVAILABLE: 'Free',
  OCCUPIED: 'Occupied',
  RESERVED: 'Reserved',
  OUT_OF_SERVICE: 'Offline',
  MAINTENANCE: 'Maintenance',
  FAMILY: 'Family',
  AUTHORIZED_REPRESENTATIVE: 'Authorized representative',
  FUNERAL_HOME: 'Funeral home',
  POLICE: 'Police',
  GOVERNMENT: 'Government',
  TRANSFER: 'Transfer',
  OTHER: 'Other',
  PRIVATE_VIEWING: 'Private viewing',
  FAMILY_VIEWING: 'Family viewing',
  PRAYER: 'Prayer',
  RELIGIOUS_CEREMONY: 'Religious ceremony',
  MEMORIAL: 'Memorial',
  FUNERAL_SERVICE: 'Funeral service',
  VIGIL: 'Vigil',
  NON_RELIGIOUS_SERVICE: 'Non-religious service',
};

export async function printMortuaryTag(opts: { bodyNumber: string; scanToken: string; chamber?: string }) {
  const { openPrintWindow } = await import('./printUtils');
  await openPrintWindow(
    `<div class="section"><p><strong>MORTUARY ${opts.bodyNumber}</strong></p><p>Scan token: ${opts.scanToken}</p><p>${opts.chamber || 'Unassigned'}</p></div>`,
    'Mortuary Body Tag',
  );
}

export function prettyMortuary(value?: any) {
  if (value == null || value === '') return '—';
  const key = String(value);
  if (LABELS[key]) return LABELS[key];
  return key.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}
